import React, { useState, useContext, useEffect } from 'react';
import {
  Box, Typography, Button, FormControl, Select, MenuItem, FormHelperText
} from '@mui/material';

import { AppContext } from "../context/AppContext";
import CONFIG from "../utils/config";

const ugEducationOptions = [
  { value: '', label: 'Select Undergraduate (UG) Program', disabled: true },
  { value: 'Not Applicable', label: 'Not Applicable - No Cost' },
  { value: 'Reputed Indian', label: 'Reputed Indian College - ₹30 Lakhs' },
  { value: 'Premier Indian', label: 'Premier Indian College- ₹80 Lakhs' },
  { value: 'Premier Overseas', label: 'Premier Overseas College - ₹2.4 Cr' }
];

const pgEducationOptions = [
  { value: '', label: 'Select Postgraduate (PG) Program', disabled: true },
  { value: 'Not Applicable', label: 'Not Applicable - No Cost' },
  { value: 'Reputed Indian', label: 'Reputed Indian College - ₹20 Lakhs' },
  { value: 'Premier Indian', label: 'Premier Indian College - ₹50 Lakhs' },
  { value: 'Premier Overseas', label: 'Premier Overseas College - ₹1.5 Cr' }
];

const KidEducation = () => {
  const { state, actions } = useContext(AppContext);
  const [educationData, setEducationData] = useState(() =>
    state.kidsInfo.map((kid, index) => {
      const fallback = { ug: '', pg: '' };
      const saved = state.kidsEducation?.[index] || {};
      return {
        ...fallback,
        ...saved,
        ug_fees: CONFIG.ug[saved.ug] || 0,
        ug_fees_FV: 0,
        pg_fees: CONFIG.pg[saved.pg] || 0,
        pg_fees_FV: 0,
      };
    })
  );



  useEffect(() => {
    const updated = educationData.map((entry, idx) => {
      const Age = state.kidsInfo[idx]?.Age || 0;
      const ugValue = entry.ug || '';  // if fetched from backend
      const pgValue = entry.pg || '';

      const ugMatch = ugEducationOptions.find(opt => opt.value === ugValue);
      const pgMatch = pgEducationOptions.find(opt => opt.value === pgValue);

      return {
        ...entry,
        ug: ugMatch?.value || '',
        ug_fees: CONFIG.ug[ugMatch?.value] || 0,
        ug_fees_FV: ugMatch?.value
          ? CONFIG.ug[ugMatch.value] * Math.pow(1 + CONFIG.DEFAULT_INFLATION_RATE, CONFIG.DEFAULT_ug_AGE - Age)
          : 0,
        pg: pgMatch?.value || '',
        pg_fees: CONFIG.pg[pgMatch?.value] || 0,
        pg_fees_FV: pgMatch?.value
          ? CONFIG.pg[pgMatch.value] * Math.pow(1 + CONFIG.DEFAULT_INFLATION_RATE, CONFIG.DEFAULT_pg_AGE - Age)
          : 0,
      };
    });
    setEducationData(updated);
  }, []);





  const handleChange = (index, type, value) => {
    const updated = [...educationData];
    updated[index][type] = value;
    Object.assign(updated[index], state.kidsInfo[index]);
    updated[index][type + "_fees"] = CONFIG[type][value];
    updated[index][type + "_fees_FV"] = Math.max(Number(updated[index][type + "_fees"]), Number(updated[index][type + "_fees"]) * Math.pow(1 + CONFIG.DEFAULT_INFLATION_RATE, CONFIG[`DEFAULT_${type}_AGE`] - updated[index]['Age']));
    actions.updateFormData("kidsEducation", updated)
    setEducationData(updated);
    console.log(updated)
  };

  const handleFinish = () => {
    // Save data to context
    const updatedKids = state.kidsInfo.map((kid, idx) => ({
      ...kid,
      ...educationData[idx]
    }));

    actions.updateFormData('kidsInfo', updatedKids);
    // onFinish(); // Notify parent component that it's done
  };

  const isFormValid = educationData.every(kid => kid.ug && kid.pg);

  return (


    <Box sx={{ p: 2, mb: 4 }}>
      {state.kidsInfo.map((kid, kidIndex) => (
        <Box key={kidIndex}>
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            {`${kid.name.charAt(0).toUpperCase()}${kid.name.slice(1).toLowerCase()}'s Education`}
          </Typography>

          {/* UG Education Section */}
          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth >
              <Select
                value={educationData[kidIndex].ug}
                onChange={(e) => handleChange(kidIndex, 'ug', e.target.value)}
                displayEmpty
                sx={{
                  borderRadius: 2,
                  '& .MuiSelect-select': { py: { xs: 1.5, sm: 2 } }
                }}
              >
                {ugEducationOptions.map((option) => (
                  ugEducationOptions[0].label = `Select Undergrad for ${kid.name}`,
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                    sx={{ py: { xs: 1, sm: 1.5 } }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {state.kidsInfo[kidIndex]?.Age > 18 && (
                <FormHelperText >Child age is more than 18 years</FormHelperText>
              )}
            </FormControl>
          </Box>


          {/* PG Education Section */}
          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth >
              <Select
                value={educationData[kidIndex].pg}
                onChange={(e) => handleChange(kidIndex, 'pg', e.target.value)}
                displayEmpty
                sx={{
                  borderRadius: 2,
                  '& .MuiSelect-select': { py: { xs: 1.5, sm: 2 } }
                }}
              >
                {pgEducationOptions.map((option) => (
                  pgEducationOptions[0].label = `Select Postgrad for ${kid.name}`,
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                    sx={{ py: { xs: 1, sm: 1.5 } }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {state.kidsInfo[kidIndex]?.Age > 22 && (
                <FormHelperText>Child age is more than 22 years</FormHelperText>
              )}
            </FormControl>
          </Box>

        </Box>
      ))}
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 3, display: "block" }}
      >
        Note: We assume undergraduate education at age 18 and postgraduate education at age 22.
      </Typography>

    </Box>

  );
};

export default KidEducation;